import React, { useEffect, useState } from "react";
import { Loading } from "./loading";
import { FormGroup, Label, Col } from "reactstrap";
const DataRegisterComponent = () => {
    // console.log("registerId", registerId);
    const user = JSON.parse(localStorage.getItem("userData"))
    const [loading, setLoading] = useState(false);
    const [dataRegister, setDataRegister] = useState([]);


    useEffect(() => {
        async function getDataRegister() {

            setLoading(true)
            let postData = new FormData();
            postData.append("id", user.registerId)
            try {
                let res = await fetch("/api/Users/getUsersData/", {
                    method: "POST",
                    body: postData,
                });
                let resJson = await res.json();
                setDataRegister(resJson.dataenum);
                // console.log("resJson =>", resJson)

            } catch (e) {
                // console.log("err => ", e)
            } finally {
                setLoading(false);
            }
        }
        getDataRegister();
    }, [])

    if (loading) { return <Loading /> }
    return (
        <>
            {dataRegister?.map((data, i) => (
                <div key={i}>
                    <FormGroup>
                        <Label>ชื่อ (ผู้ขอรับเงิน)</Label>
                        <p style={{ lineHeight: "2rem" }} className="rounded-pill text-center input-color border border-1">{data.fullName ? data.fullName : "-"}</p>
                    </FormGroup>


                    <FormGroup>
                        <Label>{data.typeName === "นิติบุคคล" ? "เลขที่ทะเบียนนิติบุคคล 13 หลัก" : "เลขที่บัตรประจำตัวประชาชน 13 หลัก"}</Label>
                        <p style={{ lineHeight: "2rem" }} className="rounded-pill text-center input-color border border-1">{data.customerNo}</p>
                    </FormGroup>

                    <FormGroup>
                        <Label>ประกอบกิจการประเภท</Label>
                        <p style={{ lineHeight: "2rem" }} className="rounded-pill text-center input-color border border-1">{data.businessType}</p>
                    </FormGroup>


                    {data.typeName === "นิติบุคคล" ? (
                        <>
                            {data.address?.map((address, j) => (
                                <React.Fragment key={j}>
                                    <Label>ที่อยู่สถานประกอบการ</Label>
                                    <div className="px-4 pt-4">
                                        <FormGroup row>
                                            <Label
                                                for="addNo"
                                                sm={2}
                                            >
                                                เลขที่
                                            </Label>
                                            <Col sm={4}>
                                                <p style={{ lineHeight: "2rem" }} className="rounded-pill text-center input-color border border-1">{address.addNo}</p>
                                            </Col>

                                            <Label
                                                for="moo"
                                                sm={2}
                                            >
                                                หมู่ที่
                                            </Label>
                                            <Col sm={4}>
                                                <p style={{ lineHeight: "2rem" }} className="rounded-pill text-center input-color border border-1">{address.addMoo ? address.addMoo : "-"}</p>
                                            </Col>
                                        </FormGroup>

                                        <FormGroup row>
                                            <Label
                                                for="soi"
                                                sm={2}
                                            >
                                                ซอย
                                            </Label>
                                            <Col sm={4}>
                                                <p style={{ lineHeight: "2rem" }} className="rounded-pill text-center input-color border border-1">{address.addSoi ? address.addSoi : "-"}</p>
                                            </Col>
                                            <Label
                                                for="street"
                                                sm={2}
                                            >
                                                ถนน
                                            </Label>
                                            <Col sm={4}>
                                                <p style={{ lineHeight: "2rem" }} className="rounded-pill text-center input-color border border-1">{address.addStreet ? address.addStreet : "-"}</p>
                                            </Col>
                                        </FormGroup>

                                        <FormGroup row>
                                            <Label
                                                for="addProvince"
                                                sm={2}
                                            >
                                                จังหวัด

                                            </Label>
                                            <Col sm={4}>
                                                <p style={{ lineHeight: "2rem" }} className="rounded-pill text-center input-color border border-1">{address.addProvince ? address.addProvince : "-"}</p>
                                            </Col>

                                            <Label
                                                for="district_id"
                                                sm={2}
                                            >
                                                อำเภอ/เขต

                                            </Label>
                                            <Col sm={4}>
                                                <p style={{ lineHeight: "2rem" }} className="rounded-pill text-center input-color border border-1">{address.addAmphur ? address.addAmphur : "-"}</p>
                                            </Col>
                                        </FormGroup>

                                        <FormGroup row>
                                            <Label
                                                for="addTumbon"
                                                sm={2}
                                            >
                                                ตำบล/แขวง

                                            </Label>
                                            <Col sm={4}>
                                                <p style={{ lineHeight: "2rem" }} className="rounded-pill text-center input-color border border-1">{address.addTumbon ? address.addTumbon : "-"}</p>
                                            </Col>

                                            <Label
                                                for="postcode"
                                                sm={2}
                                            >
                                                รหัสไปรษณีย์

                                            </Label>
                                            <Col sm={4}>
                                                <p style={{ lineHeight: "2rem" }} className="rounded-pill text-center input-color border border-1">{address.addPostCode ? address.addPostCode : "-"}</p>
                                            </Col>
                                        </FormGroup>
                                    </div>
                                </React.Fragment>
                            ))}
                        </>
                    ) : (
                        <>
                            {data.address?.map((address, j) => (
                                <React.Fragment key={j}>
                                    <Label>ที่อยู่ตามทะเบียนบ้าน</Label>
                                    <div className="px-4 pt-4">
                                        <FormGroup row>
                                            <Label
                                                for="addNo"
                                                sm={2}
                                            >
                                                เลขที่
                                            </Label>
                                            <Col sm={4}>
                                                <p style={{ lineHeight: "2rem" }} className="rounded-pill text-center input-color border border-1">{address.addNo}</p>
                                            </Col>

                                            <Label
                                                for="moo"
                                                sm={2}
                                            >
                                                หมู่ที่
                                            </Label>
                                            <Col sm={4}>
                                                <p style={{ lineHeight: "2rem" }} className="rounded-pill text-center input-color border border-1">{address.addMo ? address.addMo : "-"}</p>
                                            </Col>
                                        </FormGroup>

                                        <FormGroup row>
                                            <Label
                                                for="soi"
                                                sm={2}
                                            >
                                                ซอย
                                            </Label>
                                            <Col sm={4}>
                                                <p style={{ lineHeight: "2rem" }} className="rounded-pill text-center input-color border border-1">{address.addSoi ? address.addSoi : "-"}</p>
                                            </Col>

                                            <Label
                                                for="street"
                                                sm={2}
                                            >
                                                ถนน
                                            </Label>
                                            <Col sm={4}>
                                                <p style={{ lineHeight: "2rem" }} className="rounded-pill text-center input-color border border-1">{address.addStreet ? address.addStreet : "-"}</p>
                                            </Col>
                                        </FormGroup>

                                        <FormGroup row>
                                            <Label
                                                for="addProvince"
                                                sm={2}
                                            >
                                                จังหวัด

                                            </Label>
                                            <Col sm={4}>
                                                <p style={{ lineHeight: "2rem" }} className="rounded-pill text-center input-color border border-1">{address.addProvince ? address.addProvince : "-"}</p>
                                            </Col>

                                            <Label
                                                for="district_id"
                                                sm={2}
                                            >
                                                อำเภอ/เขต

                                            </Label>
                                            <Col sm={4}>
                                                <p style={{ lineHeight: "2rem" }} className="rounded-pill text-center input-color border border-1">{address.addAmphur ? address.addAmphur : "-"}</p>
                                            </Col>
                                        </FormGroup>

                                        <FormGroup row>
                                            <Label
                                                for="addTumbon"
                                                sm={2}
                                            >
                                                ตำบล/แขวง

                                            </Label>
                                            <Col sm={4}>
                                                <p style={{ lineHeight: "2rem" }} className="rounded-pill text-center input-color border border-1">{address.addTumbon ? address.addTumbon : "-"}</p>
                                            </Col>

                                            <Label
                                                for="postcode"
                                                sm={2}
                                            >
                                                รหัสไปรษณีย์

                                            </Label>
                                            <Col sm={4}>
                                                <p style={{ lineHeight: "2rem" }} className="rounded-pill text-center input-color border border-1">{address.addPostCode ? address.addPostCode : "-"}</p>
                                            </Col>
                                        </FormGroup>
                                    </div>
                                </React.Fragment>
                            ))}

                            {data.cAddress?.map((address, j) => (
                                <React.Fragment key={j}>
                                    <Label>ที่อยู่ปัจจุบัน (ที่ติดต่อได้)</Label>
                                    <div className="px-4 pt-4">
                                        <FormGroup row>
                                            <Label
                                                for="addNo"
                                                sm={2}
                                            >
                                                เลขที่
                                            </Label>
                                            <Col sm={4}>
                                                <p style={{ lineHeight: "2rem" }} className="rounded-pill text-center input-color border border-1">{address.addNo}</p>
                                            </Col>

                                            <Label
                                                for="moo"
                                                sm={2}
                                            >
                                                หมู่ที่
                                            </Label>
                                            <Col sm={4}>
                                                <p style={{ lineHeight: "2rem" }} className="rounded-pill text-center input-color border border-1">{address.addMo ? address.addMo : "-"}</p>
                                            </Col>
                                        </FormGroup>

                                        <FormGroup row>
                                            <Label
                                                for="soi"
                                                sm={2}
                                            >
                                                ซอย
                                            </Label>
                                            <Col sm={4}>
                                                <p style={{ lineHeight: "2rem" }} className="rounded-pill text-center input-color border border-1">{address.addSoi ? address.addSoi : "-"}</p>
                                            </Col>

                                            <Label
                                                for="street"
                                                sm={2}
                                            >
                                                ถนน
                                            </Label>
                                            <Col sm={4}>
                                                <p style={{ lineHeight: "2rem" }} className="rounded-pill text-center input-color border border-1">{address.addStreet ? address.addStreet : "-"}</p>
                                            </Col>
                                        </FormGroup>

                                        <FormGroup row>
                                            <Label
                                                for="addProvince"
                                                sm={2}
                                            >
                                                จังหวัด

                                            </Label>
                                            <Col sm={4}>
                                                <p style={{ lineHeight: "2rem" }} className="rounded-pill text-center input-color border border-1">{address.addProvince ? address.addProvince : "-"}</p>
                                            </Col>

                                            <Label
                                                for="district_id"
                                                sm={2}
                                            >
                                                อำเภอ/เขต

                                            </Label>
                                            <Col sm={4}>
                                                <p style={{ lineHeight: "2rem" }} className="rounded-pill text-center input-color border border-1">{address.addAmphur ? address.addAmphur : "-"}</p>
                                            </Col>
                                        </FormGroup>

                                        <FormGroup row>
                                            <Label
                                                for="addTumbon"
                                                sm={2}
                                            >
                                                ตำบล/แขวง

                                            </Label>
                                            <Col sm={4}>
                                                <p style={{ lineHeight: "2rem" }} className="rounded-pill text-center input-color border border-1">{address.addTumbon ? address.addTumbon : "-"}</p>
                                            </Col>

                                            <Label
                                                for="postcode"
                                                sm={2}
                                            >
                                                รหัสไปรษณีย์

                                            </Label>
                                            <Col sm={4}>
                                                <p style={{ lineHeight: "2rem" }} className="rounded-pill text-center input-color border border-1">{address.addPostCode ? address.addPostCode : "-"}</p>
                                            </Col>
                                        </FormGroup>
                                    </div>
                                </React.Fragment>
                            ))}
                        </>
                    )}
                </div>
            ))}
        </>
    )
}
export default DataRegisterComponent;